import { Fragment, useState } from "react";
import { ChevronsRight } from "react-feather";
import { Btn, H6, P } from "../../../../AbstractElements";
import { FullScreenModal } from "../../../../Constants/Constants";
import { FullScreenModalData } from "../../../../Data/UiKits/Modal";
import CommonModal from "../Common/CommonModal";

const FullScreen = () => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const data = {
    isOpen: modal,
    header: true,
    class: "modal-fullscreen",
    toggler: toggle,
    title: "Extra large modal",
    bodyClass: "dark-modal",
  };
  return (
    <>
      <Btn color="secondary" onClick={toggle}>{FullScreenModal}</Btn>
      <CommonModal modalData={data}>
        {FullScreenModalData &&
          FullScreenModalData.map((item, index) => (
            <Fragment key={index}>
              <div className="large-modal-header">
                <ChevronsRight />
                <H6>{item.title}</H6>
              </div>
              <P className="modal-padding-space">{item.text}</P>
            </Fragment>
          ))}
      </CommonModal>
    </>
  );
};
export default FullScreen;
